import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  modal_data: {
    height: '100%',
    width: '100%',
    maxWidth: '87.5rem',
    margin: '0 auto',
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '1.125rem 1.875rem 1.875rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      padding: '1.125rem 2.5rem 2.5rem',
    },
  },
  modal_title: {
    width: '100%',
    height: 'auto',
    padding: '1.125rem 2.5rem 1.125rem 0.9375rem',
    margin: 0,
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '0 2.5rem 1.125rem 0',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      padding: '0 2.5rem 1.125rem 0',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      padding: '0 2.5rem 1.125rem 0',
    },
  },
  modal_text_area: {
    [theme.breakpoints.up('viewportMedium')]: {
      order: 1,
    },
  },
  text_description: {
    paddingBottom: '35vh',
    borderTop: '0.0625rem solid #dbdbdb',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.25rem',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 0.375rem rgb(0 0 0 / 30%);',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: colors.acura_red,
    },
    [theme.breakpoints.up('viewportMedium')]: {
      paddingBottom: 'calc(79.5% - 1.3125rem)',
    },
  },
  modal_text: {
    height: 0,
    padding: '0.9375rem 0.9375rem 1.25rem',
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '0.625rem',
    },
  },
  modal_image_area: {
    [theme.breakpoints.up('viewportMedium')]: {
      order: 2,
    },
  },
  modal_image_container: {
    display: 'block',
    width: '100%',
    paddingBottom: '61.5%',
    [theme.breakpoints.up('viewportMedium')]: {
      paddingBottom: '80%',
    },
  },
  modal_image: {
    top: '50% !important',
    transform: `translate(0, -50%)`,
  },
  disclaimer: {
    paddingBottom: '1em',
  },
  button_container: {
    minWidth: '8.6875rem',
    maxWidth: '15.625rem',
    height: '2.5rem',
    margin: '0.3125rem 0.5625rem 0.9375rem 0',
    padding: '0 0.9375rem',
    [theme.breakpoints.up('viewportMobileMid')]: {
      margin: '0.3125rem 0 0.9375rem 0',
    },
  },
});
